export default __webpack_public_path__ + "static/media/aeroplane.03bd1d13.svg";